import { Tab, Tabs, Tooltip } from "@mui/material";
import { TAB_DATA } from "../constants/logConstants";

/**
 * Component to display a tab bar with various log categories.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.displayTab - The currently selected tab value.
 * @param {function} props.setDisplayTab - Function to update the selected tab value.
 * @param {function} props.setShowResolveButton - Function to toggle the resolve button visibility based on the selected tab.
 */
function DisplayTabs({ displayTab, setDisplayTab }) {
  const handleTabChange = (_, newValue) => setDisplayTab(newValue);

  return (
    <Tabs
      TabIndicatorProps={{ style: { background: "white" } }}
      textColor="inherit"
      value={displayTab}
      onChange={handleTabChange}
      variant="scrollable"
      scrollButtons="auto"
    >
      {TAB_DATA.map(({ label, value, tooltip }) => (
        <Tab
          label={
            <Tooltip title={tooltip}>
              <span>{label}</span>
            </Tooltip>
          }
          key={value}
          value={value}
        />
      ))}
    </Tabs>
  );
}

export default DisplayTabs;
